<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Vínculo e Acompanhamento"
            description="Cadastro e atendimento da população vinculada à eSF ou eAP no território."
            url="/dashboard"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2731"
            pageIdentifier="vinculo-acompanhamento"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw?.vinculo_acompanhamento_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.vinculo_acompanhamento_ajuda || 0
            "
            keyAjudaModalInformacao="vinculo_acompanhamento_ajuda"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link
            :to="{
              path: item.link,
              query: item.ajudaKey ? { ajudaKey: item.ajudaKey } : {},
            }"
          >
            <div class="item">
              <span
                v-if="$store.getters.getQuantidadeAjuda(item.key) > 0"
                class="item-badge"
              >
                {{ $store.getters.getQuantidadeAjuda(item.key) }}
              </span>

              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img
                v-else-if="item.imagem !== ''"
                :src="item.imagem !== '' ? item.imagem : ''"
                alt=""
              />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import CadastrosCidadaos from '@/components/icons/CadastrosCidadaos.vue'
import Acompanhamento from '@/components/icons/VinculoAcompanhamento/Acompanhamento.vue'
import EnvioApp from '@/components/icons/EnvioApp.vue'
import DesempenhoPorEquipe from '@/components/icons/IndicadoresAps/DesempenhoPorEquipe.vue'

export default {
  name: 'VinculoAcompanhamento',
  metaInfo: {
    title: 'Vínculo e Acompanhamento',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    CadastrosCidadaos,
    Acompanhamento,
    EnvioApp,
    DesempenhoPorEquipe,
  },
  computed: {
    cards() {
      // Primeiro, verifica se o estado e a propriedade vinculo_acompanhamento existem
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.vinculo_acompanhamento
      ) {
        // Clona o array vinculo_acompanhamento para evitar mutação do estado original
        const clone = [...this.$store.state.permissoes.vinculo_acompanhamento]
        // Retorna o array ordenado pela chave 'ordem'
        return clone.sort((a, b) => a.ordem - b.ordem)
      }
      return [] // Retorna um array vazio se o dashboard não estiver disponível
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
